<template>
  <div class="product-desc">
    <top-header></top-header>
			<!-- Mobile view -->
			<b-container class="product-desc--mobile d-block d-sm-block d-md-none">
				 <div class="rowbg">
				
				
				 <productimage-swiper :galleryimages="product.gallery_images"></productimage-swiper>
				 
				<h1>
				<p class="m-0" v-if="product.brand!=''"><small class="brandbtn"><b-link :href="'/brand/'+product.brand.replace(/ /g,'-')" style="color: #b34ef2;">{{product.brand}}</b-link></small> <span class="discountoffermo-txt">&nbsp;</span></p>
				  <p class="titleProduct">{{product.title}}</p>
				 
				  <small v-if="product.title!=product.short_description">{{product.short_description}}</small>
				 	<!-- <br/>
					  <small>(SKU: {{product.sku}})</small> -->
					</h1>
				  <b-row class="commissionpanel">
					<b-col cols="6" class="" v-if="$root.customer_info.role==3">				
						Commission : <span class="commFont">{{product.commission}}%</span>             
					</b-col>
					<b-col cols="6" class="commissionpanelRat" v-if="product.product_rating">
							<!-- <div class="css-49ow2m e4l4gr0"><span class="positive css-1est581 e4l4gr1"><span class="value">4.3</span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16"><title>star</title>*</svg></span><span class="css-8zatqb e4l4gr2">Based on 5308 </span></div> -->
						<div class="product-details--star-ratings-wrapper p-0" v-if="product.product_rating" >
						<b-form-rating class="w-100" readonly no-border :value="product.product_rating" precision="2"  id="popover-target-1" variant="warning" ></b-form-rating>
						<!--b-button id="popover-target-1">
							Hover Me
						  </b-button> -->
						  
						  
						  <b-popover target="popover-target-1" triggers="hover" placement="bottom" class="d-flex justify-content-center propRating">
							<!--<template #title>Popover Title</template> -->
							 <b-container>
							 <div class="headRat"><span class="headRatRat">Ratings</span> <br/>{{(reviewDatagrap.product_rating/reviewDatagrap.total_ratings
							 ).toFixed(1)}} out of 5 stars</div>
							<div class="row mb-1">
													<div class="d-flex flex-row font-md w-100">
														<div class="px-1">5</div>
														<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
														<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate5" variant="warning"></b-progress></div>
														<div class="px-1 text-right ratLeftno" >{{reviewDatagrap.rate5}}</div>
													</div>
												</div>
												<div class="row mb-1">
													<div class="d-flex flex-row font-md w-100">
														<div class="px-1">4</div>
														<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
														<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate4" variant="warning"></b-progress></div>
														<div class="px-1 text-right ratLeftno" >{{reviewDatagrap.rate4}}</div>
													</div>
												</div>
												<div class="row mb-1">
													<div class="d-flex flex-row font-md w-100">
														<div class="px-1">3</div>
														<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
														<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate3" variant="warning"></b-progress></div>
														<div class="px-1 text-right ratLeftno" >{{reviewDatagrap.rate3}}</div>
													</div>
												</div>
												<div class="row mb-1">
													<div class="d-flex flex-row font-md w-100">
														<div class="px-1">2</div>
														<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
														<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate2" variant="warning"></b-progress></div>
														<div class="px-1 text-right ratLeftno">{{reviewDatagrap.rate2}}</div>
													</div>
												</div>
												<div class="row mb-1">
													<div class="d-flex flex-row font-md w-100">
														<div class="px-1">1</div>
														<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
														<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate1" variant="warning"></b-progress></div>
														<div class="px-1 text-right ratLeftno" >{{reviewDatagrap.rate1}}</div>
													</div>
												</div> 
								</b-container>
						  </b-popover>
						
						
					  </div>

					 </b-col>
				 </b-row>
				
				 <b-row>
				  <b-col cols="12">
				 <product-price :details="true" :product="product"></product-price>
				 </b-col>
				 <b-col cols="12" style="display: none;">
				 <!-- *********** Offer20 Panel ************ -->
					<product-offerpdp :offertweb="0"></product-offerpdp>
				 </b-col>
				 </b-row>
				  
				 <b-row v-if="product.dimension!='' && product.dimension!=null">
					<b-col cols="12">
						<h6>Dimension: <span class="dimensionFont ">{{product.dimension}}</span></h6>
					</b-col>
				 </b-row>
				 
				  
				 <b-row >
					<b-col cols="6" v-if="product.expiry_date!='' && product.expiry_date!=null">
					  <p class="pt-1 text-left text-secondary origiProduct d-block d-sm-block d-md-none" v-if="product.expiry_date!=null"><small> Expiry Date : {{product.expiry_date}}</small></p>
					</b-col>
					<b-col cols="6">
						  <p class="pt-1 text-left text-secondary origiProduct d-block d-sm-block d-md-none"><small>Country of Origin : {{product.country_origin=='In' || product.country_origin=='IN'?'India':product.country_origin}}</small></p>
					</b-col>
				 </b-row>
				 
				
				
				
				
			 </div>
			  <div class="rowbg mt-2" v-if="product.product_type == 2">
						
						  <b-row class="mb-3" v-for="(item, index) in product.variation_attributes" :key="item">
							<b-col class="sizeCol">
							  <b-row class="m-0">
								<b-col class="p-0">
								  <label class="sizelael">Select {{item}}</label>
								</b-col>
							  </b-row>
							  <b-row class="m-0 sizeRow">
								<!--<b-col v-for="variationitem in filterAttribute(product.variations, index)" :key="variationitem.sku" cols="2" class="px-1 p-1">-->
								<b-col v-for="variationitem in filterAttribute(product.variations, index)" :key="variationitem.sku" class="px-1 p-1">
								  <div class="product-attribute" v-bind:class="{ active: selected_attributes[index] == variationitem.attributes[index].value }" v-on:click="onSelectAttribute(variationitem, index)">
								  {{variationitem.attributes[index].value}}
									<!--{{variationitem.attributes[index]}} 
									<b-img :src="variationitem.src"></b-img> -->
								  </div>
								</b-col>
							  </b-row>
							 <div class="text-right scmobileview" v-if="thisisweb==0" > <size-chart :productData="product"></size-chart></div>
							</b-col>
						  </b-row>
							<!-- {{selected_attributes_id}}
							{{product.id}} -->
						  <p v-if="$root.addtocartAlert!=''"><b-alert show variant="warning" class="addtocartAlert">{{$root.addtocartAlert}}</b-alert>
						  </p> 
						  <!-- <p>{{selected_attributes}}</p> -->
						

			  </div>
			  <div class="rowbg mt-2">
				<div class="product-buying-ctas-wrapper text-center">
					  <b-button v-if="product.stock_qty > 0" pill type="button" class="mr-3 AddToCart" @click="$root.updateCart(product, product_qty,selected_attributes,selected_attributes_id),initload()">Add to Bag</b-button>
					  <b-button v-if="product.stock_qty > 0" pill type="button" @click="$root.updateCart(product,product_qty,selected_attributes,selected_attributes_id),initload()" v-b-toggle.cartPanel class="AddToCart">Buy Now</b-button>
					  <b-button v-if="product.stock_qty <= 0" pill type="button">Out of stock</b-button>
					
					  <div v-if="$root.customer_info.role==3" class="float-left margin-right-half colottnshop">
					  
					  <b-link v-if="product.inshop==1"> <b-icon icon="bag" aria-hidden="true" v-b-tooltip.hover title="Already added in your Shop!" placement="bottom" :class="[product.inshop == 1 ?'inshop':'']"></b-icon></b-link>
					   <b-link v-else @click="$root.updateShare(product),product.inshop=1">
					  <b-icon  :class="[product.inshop == 1 ?'inshop':'']"  icon="bag" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom" ></b-icon>
					  </b-link>
					  
					  
					  </div>
					</div>
					
					<shareicon-button :productData="product"  iamin="product" v-if="$root.customer_info.role==3" ></shareicon-button>
			  </div>
			  
			  
			  
			  <div class="rowbg mt-2">
				<b-tabs content-class="mt-3" fill pills  class="profileTab">
				<b-tab title="Product Description" active>
							<ul class="productdesc">
								<li class="font-md"> 
									{{product.description}}
								</li> 
								<li  v-if="product.ingredients!='' && product.ingredients!=null"> 
									<p>Ingredients</p>
										{{product.ingredients}}
									
								 </li>
								<li v-if="product.dimension!='' && product.dimension!=null"> 
									<p>Dimension</p>
									{{product.dimension}}
								</li>
								
								<li>
									<h3>important info</h3>
										<b-row>
											<b-col>
												
												<h6 class="text-secondary" style="font-size: 15px;" v-if="product.expiry_date!=null"><span style="font-weight:400">Expiry Date: </span> {{product.expiry_date}} </h6>
												<h6 class="text-secondary" style="font-size: 15px;"><span style="font-weight:400">Country of Origin :</span><span> {{product.country_origin=='In' || product.country_origin=='IN'?'India':product.country_origin}}</span></h6>
											</b-col>
										</b-row>
								</li>
								
								
								
							</ul>

				 
				 
				</b-tab>

				<b-tab title="How to Use" class="p-2">
				 {{product.how_to_use || 'Not available'}}
				</b-tab>
				</b-tabs>
			  
			  </div>
			  <div class="rowbg mt-2">
				<b-tabs content-class="mt-3" fill pills  class="profileTab">
				<b-tab title="About The Seller" active>
					<b-row  >
					
					
						  <b-col cols="4">
							<!--<b-img src="../assets/product-description-page/clog-london-logo.png"></b-img>-->
							
							<b-img  rounded :alt="product.brand_name" v-if="product.business_logo=='' || product.business_logo==null" :src="$root.MEDIAPATH+'blank.jpg'" style="width:142px"></b-img>
							<b-img  rounded alt="" v-else :src="$root.MEDIAPATH+'businesslogo/'+product.business_logo.replace('_rg','_th')"  style="width: 142px;"></b-img>
							
							
						  </b-col>
						  <b-col cols="8" style="text-align:center;"> 
							<span class="product-brand-name text-capitalize">{{product.business_name||product.brandname}}</span>
							<div >
								
							   <product-rating :userrating="product.user_rating" ></product-rating>
							</div>
						  </b-col>

						
						</b-row>
				
				
					<b-row class="mt-2">
						 <b-col cols="5"  >
						  <b-button pill type="button" class="btncontact-seller" src="mailto:contactus@alluraa.com">Contact Seller</b-button>
						 </b-col>
					  <b-col cols="7">
						
						<div class="product-seller-info--contact">
						   <p v-if="product.phone" class="product-seller-info--phone-no m-0">
								<i class="fa fa-phone mr-1 mt-1" aria-hidden="true" style="font-size: 15px;"></i> <a :href="'tel:+91'+product.phone">+91 {{csPhone}}</a>
							  </p>
							  <p v-if="product.email" class="product-seller-info--email">
								<b-icon icon="envelope" class="mr-1 mt-1"></b-icon> <a href="mailto:contactus@alluraa.com">{{csEmailTo}}</a>
							  </p>
				</div>
					  </b-col>
					</b-row>

				</b-tab>

				
				</b-tabs>
			  
			  </div>
			  <div class="rowbg mt-2">
				<b-tabs content-class="mt-3" fill pills  class="profileTab">
				<b-tab title="Reviews &amp; Ratings" active>
									
						<b-row v-if="product.product_rating">
							  <b-col class="text-center" cols="12" >
								<b-form-rating class="w-50 ml-25" readonly no-border :value="product.product_rating" precision="2" variant="warning"></b-form-rating>
							  </b-col>
							  <b-col class="text-center" cols="12" >
									<div class="rate-value w-100">{{product.product_rating}}/{{product.total_ratings}} 
								<span >Based on {{product.total_ratings}} Ratings</span></div>
							  </b-col>
						  </b-row>
				
					<div class="writeRating">
					 <div v-for="review in product_reviews" :key="review.id" class="review">
						<p v-if="review.firstname">{{review.firstname}}</p>
						<p><b>{{review.subject}}</b>
						<br/>{{review.description}}</p>
						<b-col cols="4" class="review-rating">
						<!--product-rating :userrating="review.rating"></product-rating-->
						<b-form-rating class="w-50" readonly no-border :value="review.rating" precision="2" variant="warning"></b-form-rating> 
						</b-col>
					</div>
					<b-button type="button" pill class="btn--load-more" v-if="nextPage" @click="loadMore()">Load More</b-button>
				  </div>
				</b-tab>
				<b-tab title="Write a review" class="p-2">
					<b-row class="text-center" v-if="!$root.customer_info.access_key">
											<b-col>
												Write a review
												<b-link class="btn2 btn-solid" @click="addreview()">WRITE REVIEW</b-link>
											</b-col>
										</b-row>
						<b-row v-if="$root.customer_info.access_key">
								  <b-col class="text-center" cols="12" >
								  <b-row v-if="product.product_rating">
									  <b-col class="text-center" cols="12" >
										
										<b-form-rating class="w-50 ml-25" readonly no-border :value="product.product_rating" precision="2" variant="warning"></b-form-rating>
									  </b-col>
									  <b-col class="text-center" cols="12" >
											<div class="rate-value w-100">{{product.product_rating}}/{{product.total_ratings}}
									<span >Based on {{product.total_ratings}} Ratings</span></div> 
									  </b-col>
								  </b-row>
									
								  </b-col>
								  <b-col cols="12" class="writeRating">
									
									  <h1>Overall rating</h1>
									
									<p class="mb-2 prating">
									  <b-form-rating id="rating-inline-iRate-m" inline no-border @change="addreview()" size="lg" v-if="reviewData.iRateit==1" readonly :value="reviewData.iRate" variant="warning" ></b-form-rating>
									  
									  <b-form-rating v-else id="rating-inline-ratingM" inline no-border v-model="reviewForm.rating" @change="addreview()" size="lg" variant="warning"></b-form-rating>
									</p>
									<p class=" mb-1" v-if="reviewData.iRateit!=1">
									  <!--<b-form @submit="onSubmitReview" style="width:98%">
										<b-form-group label="Add a headline" label-for="review_subject" label-align="left">
										  <b-form-input
											id="review_subject"
											v-model="reviewForm.subject"
											required
											placeholder="What's most important to know?"></b-form-input>
										  </b-form-group>
										  <b-form-group label="Description:" label-for="review_description20" label-align="left">
										  <b-form-textarea
											id="review_description20"
											v-model="reviewForm.description"
											placeholder="Enter Description..."
											rows="2"
											max-rows="6"
											required></b-form-textarea>
										  </b-form-group>
										  <b-button pill type="submit" class="btncontact-seller" style="float:right;" >Submit</b-button>
										  
									  </b-form> -->
									  	<b-form  @submit.stop.prevent="onSubmitReview" style="width:90%">
											<b-form-group label="Add a headline" label-for="review_subject1" label-align="left" :state="reviewFormState.subject" invalid-feedback="Headline required!">
											  <b-form-input
												id="review_subject5"
												v-model="reviewForm.subject"
												
												placeholder="What's important to know?" :state="reviewFormState.subject" @focusin="reviewFormState.subject = null"></b-form-input>
											  </b-form-group>
											  <b-form-group label="Write Review" label-for="review_description20" label-align="left">
											  <b-form-textarea
												id="review_description20"
												v-model="reviewForm.description"
												placeholder="Any feedback for the product. What did you like or dislike?"
												rows="2"
												max-rows="6"
												></b-form-textarea>
											  </b-form-group>
											  <b-button type="submit" variant="primary">Submit</b-button>
										  </b-form>

									</p>
								  </b-col>
						</b-row>
				  </b-tab>


				</b-tabs>
			  
			  </div>

		
		</b-container>
	<!-- Web view -->
    <b-container class="product-desc--wrapper d-none d-md-block">
	<b-container style="margin-top:20px;">
		 <!--<b-breadcrumb
            :items="breadcrumbItems"
            class="breadcrumb--page"></b-breadcrumb> -->
		</b-container>	
      <b-row class="product-details--card"> 
        <b-col cols="12" md="6">
          <div class="product-desc--img-wrapper">
          <b-row> 
			<b-col cols="12" lg="9" md="9" class="d-block d-sm-block d-md-none">
               <!-- <div class="product-img--main-selected" >
                  <b-img :src="productLargeImage" alt="" fluid ></b-img>
				   
                </div> -->
              </b-col>
              <b-col cols="12"  lg="3" md="3">
                <div class="product-img--thumbnail-wrapper">
                  <ul class="pl-0">
                    
                    <li v-for="(image, index) in product.gallery_images" :key="image">
					
                      <a v-if="image!='' && image!=null" href="javascript:void(0)"  @click="changeImage(image)"  v-bind:class="{ active: (isActivethum==image)  }" :ref="'menukey'+index" >
                        <b-img  :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+image" :alt="product.title" ></b-img>
                      </a>
                    </li>
                  </ul>
                </div>
              </b-col>
              <b-col cols="12" lg="9" md="9" class="d-none d-md-block p-0">
                <div class="product-img--main-selected expand" >
                  <!--<b-img :src="productLargeImage" alt="" class="expand"></b-img>-->
                  <!-- <b-img :src="productLargeImage" alt="" ></b-img> -->
				  <!--<pic-zoom :url="productLargeImage"  :scale="4"  id="kk"></pic-zoom> -->
				  
				   <image-zoom  v-if="productLargeImage!=''"
				:regular="productLargeImage" 
				:zoom="productLargeImageUrl" 				
				:lazyload-placeholder="productLargeImageUrl">
			</image-zoom>
				  <!-- <pic-zoom url="https://www.secureftp.alluraa.com/Jaquline/30075704.jpg"  :scale="4"  id="kk2"></pic-zoom> -->
				  <!-- :big-url="productLargeImageUrl" -->
                </div>
              </b-col>
            </b-row> 
								 <b-row>
				 <b-col cols="12"  lg="3" md="3" class="d-none d-md-block" >
				 
				  </b-col>
				   <b-col cols="12" lg="9" md="9" sm="12" class="text-center">
					<shareicon-button :productData="product"  iamin="product" v-if="$root.customer_info.role==3" ></shareicon-button>
				</b-col>
				</b-row>

			</div>
			<!--<b-row>
				<b-col>
				
				
				<section class="hero is-fullheight" id="scroll-left">
					<div class="hero-body is-fullheight">
					  <div class="container">
						<div class="columns is-centered is-vcentered">
							<ProductZoomer :base-images="images" :base-zoomer-options="zoomerOptions"/>						
						</div>
					  </div>
					</div>
			  </section>
				
				
				</b-col>
			</b-row>-->
         
        </b-col>
        <b-col cols="12" md="6">
		<!-- {{imagesTe}} -->
         
            <div class=" inmobilePt">
              <div class="product-details--desc">
                <!--<span class="product-details--brand d-block text-capitalize "></span> -->
				<h3><b-link :href="'/brand/'+product.brand.replace(/ /g,'-')">{{product.brand}}</b-link></h3>
                <span class="product-details--title d-block text-capitalize">{{product.title}}</span>
                <!--<span class="product-details--color-sizes-txt d-block">{{product.sku}}</span> -->
                <span class="product-details--about d-block" v-if="product.title!=product.short_description">{{product.short_description}}</span>
				<!-- ******
					Rating & Star
					******* -->
				<b-row class="product-details--star-ratings-wrapper " v-if="product.product_rating">	
				<b-col cols="4" class="pl-0">
				<div style="float:left;width: 66%;">
				<b-form-rating class="w-50 starSmall" readonly no-border :value="product.product_rating" precision="2"  id="popover-target-2" variant="warning" ></b-form-rating>
				</div><div style="border-right:1px solid #c6c6c6"><small style="color:#000000;">{{(reviewDatagrap.product_rating/reviewDatagrap.total_ratings
						 ).toFixed(1)}}/5</small></div>
				
					<!--b-button id="popover-target-2">
						Hover Me
					  </b-button> -->
					  
					  <b-popover target="popover-target-2" triggers="hover" placement="bottom" class="d-flex justify-content-center propRating">
						<!--<template #title>Popover Title</template> -->
						 <b-container>
						 <div class="headRat"><span class="headRatRat">Ratings</span> <br/>{{(reviewDatagrap.product_rating/reviewDatagrap.total_ratings
						 ).toFixed(1)}} out of 5 stars</div>
						<div class="row mb-1">
												<div class="d-flex flex-row font-md w-100">
													<div class="px-1">5</div>
													<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
													<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate5" variant="warning"></b-progress></div>
													<div class="px-1 text-right ratLeftno" >{{reviewDatagrap.rate5}}</div>
												</div>
											</div>
											<div class="row mb-1">
												<div class="d-flex flex-row font-md w-100">
													<div class="px-1">4</div>
													<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
													<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate4" variant="warning"></b-progress></div>
													<div class="px-1 text-right ratLeftno" >{{reviewDatagrap.rate4}}</div>
												</div>
											</div>
											<div class="row mb-1">
												<div class="d-flex flex-row font-md w-100">
													<div class="px-1">3</div>
													<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
													<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate3" variant="warning"></b-progress></div>
													<div class="px-1 text-right ratLeftno" >{{reviewDatagrap.rate3}}</div>
												</div>
											</div>
											<div class="row mb-1">
												<div class="d-flex flex-row font-md w-100">
													<div class="px-1">2</div>
													<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
													<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate2" variant="warning"></b-progress></div>
													<div class="px-1 text-right ratLeftno">{{reviewDatagrap.rate2}}</div>
												</div>
											</div>
											<div class="row mb-1">
												<div class="d-flex flex-row font-md w-100">
													<div class="px-1">1</div>
													<div class="px-1"><b-icon icon="star-fill" variant="warning"></b-icon></div>
													<div class="px-1 pt-2 flex-grow-1"><b-progress :value="reviewDatagrap.rate1" variant="warning"></b-progress></div>
													<div class="px-1 text-right ratLeftno" >{{reviewDatagrap.rate1}}</div>
												</div>
											</div> 
							</b-container>
					  </b-popover>
					
					</b-col>
				  
				 <b-col class="p-0" style="color:#000000;">
					<small><b-link @click="tabIndex=1" href="#descPanel"> {{reviewDatagrap.product_rating}} Rating & {{reviewDatagrap.total_ratings}} Reviews </b-link> <!--{{(reviewDatagrap.product_rating/reviewDatagrap.total_ratings).toFixed(1)}}/5 --></small>				 
				 </b-col>
				 </b-row>

				<div class="w-100 horizontalLine" >&nbsp;</div>
				
				<!-- *********** Price Panel ************ -->
                <product-price :details="true" :product="product"></product-price>
				
				<!-- *********** Offer20 Panel ************ -->
				<product-offerpdp :offertweb="0"  style="display: none;"></product-offerpdp>
				
				<!-- *********** Quantity Panel ************ -->
				 <div class="d-block pt-2 pb-2">	 
					Quantity :
					<b-form-spinbutton id="sb-inline" size="sm" min="1" :max="product.stock_qty" step="1" inline v-model="product_qty" :options="qty_options" class="ml-1 qtyproduct"></b-form-spinbutton> 
				 </div>
				  
				  
			
              </div>
              
			 
              <div class="product-details--commission-details-wrapper" v-if="$root.customer_info.role==3">
                <!--<span>Commission : </span><b-button type="button" pill variant="warning">{{product.commission}} %</b-button>-->
				<b-button pill type="button" class="mr-3" variant="warning" >Commission</b-button>
                <span class="commFont">{{product.commission}}%</span>
              </div>
			  
			 
			 <!--<div v-if="product.dimension!='' && product.dimension!=null">
			  <b-row class="mb-3">
				<b-col class="sizeCol">
				  <b-row class="m-0">
					<b-col class="p-0">
					  <label class="sizelael">Dimension</label> : <span class="dimensionFont">{{product.dimension}}</span>
					</b-col>
				  </b-row>
				  
				</b-col>
			  </b-row>
				
			</div> -->

			  
			  
			  

				  <div v-if="product.product_type == 2">
				  <b-row class="mb-3" v-for="(item, index) in product.variation_attributes" :key="item">
					<b-col class="sizeCol">
					  <b-row class="m-0">
						<b-col class="p-0">
						  <label class="sizelael">Select {{item}}</label>
						</b-col>
					  </b-row>
					  <b-row class="m-0 sizeRow">
						<!--<b-col v-for="variationitem in filterAttribute(product.variations, index)" :key="variationitem.sku" cols="2" class="px-1 p-1">-->
						<b-col v-for="variationitem in filterAttribute(product.variations, index)" :key="variationitem.sku" class="px-1 p-1">
						  <div class="product-attribute" v-bind:class="{ active: selected_attributes[index] == variationitem.attributes[index].value }" v-on:click="onSelectAttribute(variationitem, index)">
						  {{variationitem.attributes[index].value}}
							<!--{{variationitem.attributes[index]}} 
							<b-img :src="variationitem.src"></b-img> -->
						  </div>
						</b-col>
						<b-col class="sizechartList" v-if="thisisweb==1"> <size-chart :productData="product"></size-chart></b-col>
					  </b-row>
					   <!--<size-chart :productData="product"></size-chart>-->
					</b-col>
				  </b-row>
					<!-- {{selected_attributes_id}}
					{{product.id}} -->
				  <p v-if="$root.addtocartAlert!=''"><b-alert show variant="warning" class="addtocartAlert">{{$root.addtocartAlert}}</b-alert>
				  </p> 
				  <!-- <p>{{selected_attributes}}</p> -->
				  
				  
				
				  
				</div>
				
              <b-row align-v="center" >
				<!-- ********** 
					Add TO Cart Panel 
					********** -->
                <b-col cols="6" class="product-quantity-select-wrapper" style="padding-top: 28px;padding-bottom:8px;">
                  <!-- <b-form-select class="product-quantity m-0" v-model="product_qty" :options="qty_options" ></b-form-select>
				  <p class="text-secondary" ><small>Quantity</small></p> -->
						<b-row>
						   <b-col class="text-center">
							<div class="product-buying-ctas-wrapper">
							<div v-if="$root.customer_info.role==3" class="float-left margin-right-half colottnshop">
							  <b-link v-if="product.inshop==1"> <b-icon icon="bag" aria-hidden="true" v-b-tooltip.hover title="Already added in your Shop!" placement="bottom" :class="[product.inshop == 1 ?'inshop':'']"></b-icon></b-link>
							   <b-link v-else @click="$root.updateShare(product),product.inshop=1">
							  <b-icon  :class="[product.inshop == 1 ?'inshop':'']"  icon="bag" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom" ></b-icon>
							  </b-link>
							  
							  
							  </div>
							
							  <b-button squared  v-if="product.stock_qty > 0" type="button"  @click="$root.updateCart(product, product_qty,selected_attributes,selected_attributes_id),initload()" :class="[$root.customer_info.role==3 ?'':'w-100']" class="AddToCart" >Add TO BAG</b-button>
							  <b-button squared v-if="product.stock_qty <= 0" pill type="button">Out of stock</b-button>
							  
							</div>
							<p v-if="$root.addtocartAlert!=''" class="d-block d-sm-block d-md-none"><b-alert show variant="warning" class="addtocartAlert">{{$root.addtocartAlert}}</b-alert>
							  </p> 

						</b-col>
					</b-row>

				  
                </b-col>
				<!-- ********** 
					 Cheeck PIN Code 
				************** -->
				
                <b-col cols="6">
                  <!-- <b-img src="../assets/product-description-page/icons/location-icon.png"></b-img>
                  <span class="ml-2 d-inline-block">Delivery Options</span> -->
				  <b-row >
					
					<b-col  class="product-check-location-availability" style="margin-bottom:12px;">
					<p class=" m-0 text-left text-secondary" ><b-img src="../assets/product-description-page/icons/location-icon.png" height="18"></b-img> <small>Delivery Optios</small></p>
                    <b-input-group>
                      <b-form-input type="number" placeholder="Enter Pincode"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn--check-pincode-cta" type="button" disabled>Check</b-button>
                      </b-input-group-append>
                    </b-input-group>
					<!--<p class="pt-1 text-right text-secondary" ><small>Country of Origin : {{product.country_origin=='In' || product.country_origin=='IN'?'India':product.country_origin}}</small></p>-->
                  </b-col>
				  </b-row>
                </b-col>
              </b-row> 
			 
            </div>
            <!--<div class="product-buying-ctas-wrapper">
              <b-button v-if="product.stock_qty > 0" pill type="button" class="mr-3" @click="$root.updateCart(product, product_qty,selected_attributes)">Add to Cart</b-button>
              <b-button v-if="product.stock_qty > 0" pill type="button" @click="$root.updateCart(product,product_qty,selected_attributes)" v-b-toggle.cartPanel>Buy Now</b-button>
              <b-button v-if="product.stock_qty <= 0" pill type="button">Out of stock</b-button>
            </div> -->
			<banner-product></banner-product>
			
          
        </b-col>
      
			 <div class="product-desc--more-tabs-wrapper mt-4 w-100" id="descPanel">
				<b-tabs
				  active-tab-class="product-desc-active-tab-content mt-3"
				  nav-class="product-desc-tabs" fill v-model="tabIndex">
				  <b-tab title="Product Description" active>
					<!--{{product.description}}-->
						<ul class="productdesc">
							<li class="font-md"> 
								{{product.description}}
							</li> 
							<li  v-if="product.ingredients!='' && product.ingredients!=null"> 
								<p>Ingredients</p>
									{{product.ingredients}}
								
							 </li>
							<li v-if="product.dimension!='' && product.dimension!=null"> 
								<p>Dimension</p>
								{{product.dimension}}
							</li>
							<li  v-if="product.how_to_use!='' && product.how_to_use!=null"> 
								<p>How to Use</p>
								{{product.how_to_use || 'Not available'}}
							</li>
							<li>
								<p>important info</p>
									<b-row>
										<b-col>
											
											<h6 class="text-secondary" style="font-size: 15px;" v-if="product.expiry_date!=null"><span style="font-weight:400">Expiry Date: </span> {{product.expiry_date}} </h6>
											<h6 class="text-secondary" style="font-size: 15px;"><span style="font-weight:400">Country of Origin :</span><span> {{product.country_origin=='In' || product.country_origin=='IN'?'India':product.country_origin}}</span></h6>
										</b-col>
									</b-row>
							</li>
							
							<li> 
								<p>Seller: <span style="color: #b24bf1;">{{product.business_name||product.brandname}}</span></p>
							
									 <b-row>
									  <b-col lg="8" md="8" sm="12" class="product-about-content-wrapper">
										<b-row>
										  <b-col cols="3">
											<!--<b-img src="../assets/product-description-page/clog-london-logo.png"></b-img>-->
											
											<b-img  rounded :alt="product.brand_name" v-if="product.business_logo=='' || product.business_logo==null" :src="$root.MEDIAPATH+'blank.jpg'" style="width:142px"></b-img>
											<b-img  rounded alt="" v-else :src="$root.MEDIAPATH+'businesslogo/'+product.business_logo.replace('_rg','_th')"  style="width: 142px;"></b-img>
											
										  </b-col>
										  <b-col cols="9"> 
											<span class="product-brand-name text-capitalize">{{product.business_name||product.brandname}}</span>
											<div class="d-flex">
											   <product-rating :userrating="product.user_rating"></product-rating>
											</div>
										  </b-col>

										  <!--b-col cols="12">
											<p class="product-info-text mt-3">
											  Clog London is a footwear brand with shoes at its heart
											  offering an empowered sense of glamour and playfully
											  daring spirit. With the goal of creating a global luxury
											  leather footwear business, Clog London was founded in
											  2014. The brand's reputation as a 'Celebrity Favorite'
											  helped to fuel its rapid expansion
											</p>
										  </b-col-->
										</b-row>
									  </b-col>
									  <b-col lg="4" md="4" sm="12" class="product-about-seller-wrapper">
										<div class="text-center">
										  <b-button pill type="button" class="btn--contact-seller" src="mailto:contactus@alluraa.com">Contact Seller</b-button>
										</div>
										<div class="product-seller-info--contact">
										  <span v-if="product.phone" class="product-seller-info--phone-no">
											<i class="fa fa-phone mr-1 mt-1" aria-hidden="true" style="font-size: 15px;"></i> <a :href="'tel:+91'+product.phone">+91 {{csPhone}}</a>
										  </span>
										  <span v-if="product.email" class="product-seller-info--email">
											<b-icon icon="envelope" class="mr-1 mt-1"></b-icon> <a href="mailto:contactus@alluraa.com">{{csEmailTo}}</a>
										  </span>
										</div>
									  </b-col>
									</b-row>
									
							</li>
							
							
						</ul>

				  </b-tab>
				 
				  <b-tab title="Customer Reviews">
					<h5>Reviews &amp; Ratings</h5>
					<b-row>
					  <b-col class="text-center" v-if="product.product_rating" cols="4">
						<b-form-rating class="w-50" readonly no-border :value="product.product_rating" precision="2" variant="warning" ></b-form-rating>
						<div class="rate-value w-50">{{product.product_rating}}/{{product.total_ratings}} <span class="font-sm" >Based on {{product.total_ratings}} Ratings</span></div>
					   <!-- <div class="w-50 font-sm">Based on {{product.total_ratings}} Ratings</div> -->
					  </b-col>
					  <b-col cols="8">
						<div v-for="review in product_reviews" :key="review.id" class="review">
							<p v-if="review.firstname">{{review.firstname}}</p>
							<p><b>{{review.subject}}</b>
							<br/>{{review.description}}</p>
							<b-col cols="4" class="review-rating">
							<!--product-rating :userrating="review.rating"></product-rating-->
							<b-form-rating class="w-50" readonly no-border :value="review.rating" precision="2" variant="warning" ></b-form-rating> 
							</b-col>
						</div>
						<b-button type="button" pill class="btn--load-more" v-if="nextPage" @click="loadMore()">Load More</b-button>
					  </b-col>
					</b-row>
				  </b-tab>
				  <b-tab title="Write a review">
					<b-row class="text-center" v-if="!$root.customer_info.access_key">
											<b-col>
												Write a review
												<b-link class="btn2 btn-solid" @click="addreview()">WRITE REVIEW</b-link>
											</b-col>
										</b-row>
						<b-row v-if="$root.customer_info.access_key">
								  <b-col class="text-center" cols="4" >
									<span v-if="product.product_rating">
									<b-form-rating class="w-50" readonly no-border :value="product.product_rating" precision="2" variant="warning"></b-form-rating>
									<div class="rate-value w-50">{{product.product_rating}}/{{product.total_ratings}}
									<span class="font-sm">Based on {{product.total_ratings}} Ratings</span></div> 
									</span>
								  </b-col>
								  <b-col cols="8">
									<div class="row">
									  <label class="mb-0">Overall rating</label>
									</div>
									<div class="row mb-2 prating">
									  <b-form-rating id="rating-inline-iRate" inline no-border @change="addreview()" size="lg" v-if="reviewData.iRateit==1" readonly :value="reviewData.iRate" variant="warning"			  ></b-form-rating>
									  <b-form-rating v-else id="rating-inline-rating" inline no-border v-model="reviewForm.rating" @change="addreview()" size="lg" variant="warning"></b-form-rating>
									</div>
									<div class="row mb-1" v-if="reviewData.iRateit!=1">
									  <b-form  @submit.stop.prevent="onSubmitReview" style="width:90%">
										<b-form-group label="Add a headline" label-for="review_subject1" label-align="left" :state="reviewFormState.subject" invalid-feedback="Headline required!">
										  <b-form-input
											id="review_subject5"
											v-model="reviewForm.subject"
											
											placeholder="What's important to know?" :state="reviewFormState.subject" @focusin="reviewFormState.subject = null"></b-form-input>
										  </b-form-group>
										  <b-form-group label="Write Review" label-for="review_description20" label-align="left">
										  <b-form-textarea
											id="review_description20"
											v-model="reviewForm.description"
											placeholder="Any feedback for the product. What did you like or dislike?"
											rows="2"
											max-rows="6"
											></b-form-textarea>
										  </b-form-group>
										  <b-button type="submit" variant="primary">Submit</b-button>
									  </b-form>
									</div>
								  </b-col>
						</b-row>
				  </b-tab>
				</b-tabs>
			  </div>

	  </b-row>

	  <productdetail-swiper :products="related_products" :showQuickViewListener="$root.showQuickView" heading="SIMILAR PRODUCTS"></productdetail-swiper>
	  
	  <!--<productdetail-swiper :products="related_products" :showQuickViewListener="$root.showQuickView" heading="CUSTOMERS ALSO VIEWED"></productdetail-swiper> -->
    </b-container>
	 
    <top-footer></top-footer>
  </div>
</template>


<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import ProductRating from "@/components/product-rating.vue";
import ProductPrice from "@/components/product-price.vue";

//import ProductSwiper from "@/components/product-swiper.vue";
import ProductdetailSwiper from "@/components/productdetail-swiper.vue";
import ProductimageSwiper from "@/components/productimage-swiper.vue";
import ShareiconButton from "@/components/shareiconButton.vue";
import BannerProduct from "@/components/home/BannerProduct.vue";
import ProductOfferPdp from "@/components/product-offer-pdp.vue";
import SizeChart from '@/components/size-chart.vue';
import imageZoom from 'vue-image-zoomer';
import '../assets/product.scss';

export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
    "top-header": Header,
		"top-footer": Footer,
		//"product-swiper": ProductSwiper,
		"productdetail-swiper": ProductdetailSwiper,
		"productimage-swiper": ProductimageSwiper,
		//"quickview": Quickview,
    "product-rating": ProductRating,
    "product-price": ProductPrice,
	"shareicon-button": ShareiconButton,
	"banner-product": BannerProduct,
	"product-offerpdp": ProductOfferPdp,
	"size-chart": SizeChart,
	imageZoom
	
	},
  computed: {
    // a computed getter
    productLargeImage: function () {
      // `this` points to the vm instance
      //console.log("---->>"+this.$root.MEDIAAPI+'tool/get_image?size=400x400&src='+this.product.image);
	//var imgR = Math.floor(Math.random(1234451)*10)

     //return this.$root.MEDIAAPI+'tool/get_image?size=400x400&src='+this.product.image+'?'+imgR;
	 if(this.product.image!='' && this.product.image!=null){
     return this.$root.MEDIAAPI+'toolimage/get_image?size=400x400&src='+this.product.image;
	 }else{
	 var imgR=''
	 return imgR;
	 }
      //return this.product.image;

      //return this.product.image;
    },
	productLargeImageUrl: function () {
      //return this.product.image;
	   if(this.product.image!='' && this.product.image!=null){
		return this.product.image.replace('http:','https:');
		//return this.product.image.replace('http:','http:');
		}else{
		 var imgR=''
		 return imgR;
		}
	 
    }
  },
	mounted(){
		this.initload();
		
		/* console.log(this.$refs)
	   console.log(this.$refs.menu0);
	   // Click menu item 2 seconds after mounting
	  // this.$refs.menu0.click();
	   this.$refs.menu0.$el.click(); */

		//console.log('Current Swiper instance object', this.mySwiper)
		//this.$refs.rpswiper.$swiper.slideTo(3, 1000, false);
		
		/* console.log(''this.$refs);
		console.log(this.$refs.menukey1);
		console.log(this);
		setTimeout(() => {
		console.log(this);
		//this.$refs.menukey1.click();
		}, 2000);*/
		
		if(window.innerWidth < 700){
			this.thisisweb=0;
		}
		
		
	},
	data() {
		return{
		
      swiperOption: {
            direction: 'horizontal',
            initialSlide: 0,
            slidesPerGroup: 1,
            loop: false,
            watchSlidesVisibility: true,
            loopFillGroupWithBlank: true,
            on: {
                init: function () {
                   // console.log('swiper initialized');
                },
                slideChange: function() {
                   // console.log('slide changed');
                }
            },
            fadeEffect: {
                crossFade: true
            },
            isActivethum:'',
        },
      product: {
				price: 0,
				special_price: 0,
				bars: [{id:1, value:4},{id:2, value:3},{id:3, value:2.4}]
			},
			product_qty: 1,
      nextPage:0,
			modal_data: {
				price: 0,
				special_price: 0
			},
			modal_data_qty: 1,
			qty_options: [
				{ value: 1, text: '1' },
				{ value: 2, text: '2' },
				{ value: 3, text: '3' },
				{ value: 4, text: '4' },
				{ value: 5, text: '5' },
				{ value: 6, text: '6' }
			],
			url: this.$root.WEBURL+'loadproduct',
			urlSlug: this.$root.WEBURL+'loadproductSlug',
		  reviewUrl: this.$root.WEBURL+'product-review',
		  reviewGrapUrl: this.$root.WEBURL+'product-reviewgrap', 
		  addreviwurl: this.$root.WEBURL+'new-rating',
			empty_data: {
				price: 0,
				special_price: 0
			},
			related_products: [],
			//selected_attributes: [],
			selected_attributes: [],
			selected_attributes_id: '',
      product_reviews:[],
      seller:{
        phone:'',
        email:'',
        image:''
      },
      textVal:'',
			reviewForm:{
				subject: '',
				description: '',
				rating:null,
				productid:'',
			},
			reviewFormState:{
				subject: null,
				description: null,
				rating:null,
				productid:'',
			},
      
			reviewData:{"total_review":10,"total_user":3,"iRate":4,"iRateit":0,"reviewRate":{"rate5":20,"rate4":3,"rate3":1,"rate2":6,"rate1":0}},
			reviewDatagrap:[],
			//ratingReview:'Demo Test',
			imagesTe:{thumbs:[],normal_size:[],large_size:[]},
			
		  
		  csEmailTo:'',
		  csEmail:'',
		  csPhone:'',
		   breadcrumbItems: [
				{
				  text: "Home",
				  href: "/",
				},
				{
				  text: "Cosmetics",
				  active: true,
				},
			  ],
			thisisweb:1,
			tabIndex:0,
		};
		
	},
	methods: {
            changeImageMe(){
				//console.log('Img Me2'+image);
			  setTimeout(() => {
				this.$refs.menukey0[0].click();
				}, 2000);
            },changeImage(image){
				//console.log('Img');
			/* var imgRR = Math.floor(Math.random(1234451)*10)
              this.product.image = image+'?'+imgRR;*/
              this.product.image = image;
              this.isActivethum=image;
            },
            addreview(){
                var self = this;
                //console.log("-----login----");
                //console.log(self.$root.customer_info.access_key,'--->>><<<---');
                if(self.$root.customer_info.access_key == ''){
                    self.$router.push('/login', {
                        redirect: '/product/'+self.$route.params.productid+'/review/add'
                    });
                }
            },
            resetQuickView(){
                //var self = this;
                //self.modal_data = Object.assign({}, self.empty_data);
            },
            onSelectAttribute(variation, index){
                var t = this.selected_attributes.slice();
                t[index] = variation.attributes[index].value;
                this.selected_attributes = t;
                this.selected_attributes_id = variation.attributes[index].id;
				this.$root.addtocartAlert ='';
            },
            filterAttribute(variations, index){
                var self = this;
                var filterarr = [];
                if(index == 0){
                        return variations.filter(function (variation) {
                                if(filterarr.indexOf(variation.attributes[index].value) == -1){
                                        filterarr.push(variation.attributes[index].value);
                                        return true;
                                }
                                return false;
                        })
                }else{
                        return variations.filter(function (variation) {
                                //console.log(self.selected_attributes[index-1]);
                                if(variation.attributes[index-1].value == self.selected_attributes[index-1]){
                                        //filterarr.push(variation.attributes[index].value);
                                        return true;
                                }
                                return false;
                        })
                }
            },
            filterAttribute222(variations, index){
                var filterarr = [];
                if(index == 0){
                    return variations.filter(function (variation) {
                        if(filterarr.indexOf(variation.attributes[index].value) == -1){
                            filterarr.push(variation.attributes[index].value);
                            return true;
                        }
                        return false;
                    })
                }else{
                    return variations.filter(function (variation) {
                        if(filterarr.indexOf(variation.attributes[index].value) == -1){
                            filterarr.push(variation.attributes[index].value);
                            return true;
                        }
                        return false;
                    })
                }
            },
            filterImages: function (items) {
                return items.filter(function (item) {
                    return item  != ''
                })
            },
            initload(){
                var self = this;
				var loadProductUrl = self.url;
				 if (typeof(self.$route.params.productTitel)!= "undefined"){
					loadProductUrl = self.urlSlug;
				 }
				
				//console.log('asdsad'+self.$route.params.productTitel);
				
				//return false;
				
                self.axios.post(loadProductUrl, {
                    accesskey: self.$session.get('access_key'),
                    productid: self.$route.params.productid
                }).then(function (response)  {
                  //console.log(response);
                    if(response.data.error == 0 || response.data.error == '0'){
						//console.table(response.data);
                        self.product = response.data.result.product_record;
                        self.product.gallery_images = JSON.parse(self.product.gallery_images);
                        self.isActivethum=self.product.image;
						self.csEmail=self.product.cs_email!=null?self.product.cs_email:self.product.email;
						self.csEmailTo='XXXX'+'@'+self.csEmail.split('@')[1];
						var contact_number=self.product.cs_phone!=null?self.product.cs_phone:self.product.phone;
						
						//var contact_number='9289261134'
						var phoneNo = contact_number.substr(0, 3);
						phoneNo+= ' XXXX ';
						phoneNo+= contact_number.substr(7, 4);
						self.csPhone = phoneNo;
						
						//self.csPhone=self.product.cs_phone!=null?self.product.cs_phone:self.product.phone;
						
						
                        if(self.product.product_type == 2){
                                self.product.variation_attributes = self.product.variation_attributes.split("|");
                                self.product.variations = JSON.parse(self.product.variations);
                                self.selected_attributes = self.product.default_variation.split("|");
                        }
                        //self.related_products = response.data.result.related_products;
                        self.related_products = response.data.result.related_productsDetails;
                        self.seller = response.data.result.seller;
                        self.initloadReview();
                        self.initloadReviewGrap();
                        self.changeImageMe();
						
						/* var productGalleryimg = self.product.gallery_images;
						let im=0;
						for (var i = 0; i < productGalleryimg.length; i++) {
							im++;
								var obj = productGalleryimg[i];
								console.log(i+'=img:'+obj);
								self.$root.MEDIAAPI+'tool/get_image?size=400x400&src='+obj;
							}*/

                    }else if(response.data.error == 9){
                        self.$root.forceLogout(response.data.message);
                    }
                }).catch(function (error) {
                    alert(error);
                });
				
				/* ==================== */
				window.dataLayer=[];
			 // Clear the previous ecommerce object.
				window.dataLayer.push({
				'event': 'product-details',
				  'ecommerce': {
					'detail': {
					  'actionField': {'list': 'Apparel Gallery'},    // 'detail' actions have an optional list property.
					  'products': [{
						'name': 'Triblend Android T-Shirt',         // Name or ID is required.
						'id': '12345',
						'price': '15.25',
						'brand': 'Google',
						'category': 'Apparel',
						'variant': 'Gray'
					   }]
					 }
				   }
				});
				/* ==================== */
				
				
				
            },
            loadMore(){
              this.initloadReview();
            },
            initloadReview(){
                var self = this;
                self.axios.post(self.reviewUrl, {
                    accesskey: self.$session.get('access_key'),
                    productid: self.$route.params.productid,
                    page:self.nextPage
                }).then(function (response) {
                    if(response.data.error == 0 || response.data.error == '0'){
                      for(let r of response.data.result.reviews){
                        self.product_reviews.push(r);
                      }
                      self.nextPage = response.data.result.pagination.next;
                    }else if(response.data.error == 9){
                        self.$root.forceLogout(response.data.message);
                    }
                }).catch(function (error) {
                    alert(error);
                });
            },
			initloadReviewGrap(){
                var self = this;
                self.axios.post(self.reviewGrapUrl, {
                    accesskey: self.$session.get('access_key'),
                    productid: self.$route.params.productid,
                    page:self.nextPage
                }).then(function (response) {
					
                    if(response.data.error == 0 || response.data.error == '0'){
                      /*for(let r of response.data.result.reviews){
                        self.product_reviews.push(r);
                      }
                      self.nextPage = response.data.result.pagination.next; */
					  self.reviewDatagrap = response.data.result.reviews;
					  //console.log(self.reviewDatagrap);
                    }else if(response.data.error == 9){
                        self.$root.forceLogout(response.data.message);
                    }
                }).catch(function (error) {
                    alert(error);
                });
            },
			checkFormValidityReview() {
				  var valid = true; 
				  if(this.reviewForm.subject.length < 1){
				  valid = false;
				  this.reviewFormState.subject = false;
				  }else{
				  this.reviewFormState.subject= true;
				  }
				return valid;
			},
            onSubmitReview() {
			if (!this.checkFormValidityReview()) {
				return;
			 } 
			
              //evt.preventDefault();
			  var productid  = this.product.product_id;
			  var producturl = this.product.product_slug!=null?'/'+this.product.product_slug:'/product/'+this.product.product_id;
              //this.reviewForm.productid = this.$route.params.productid;
              this.reviewForm.productid = productid;
              var self = this;
			
              self.axios.post(self.addreviwurl, {
                user_id: self.$root.customer_info.user_id,
                accesskey: self.$root.customer_info.access_key,
                data: this.reviewForm
              }).then(function (response) {
                if(response.data.error == 0 || response.data.error == '0'){	
                  self.$bvToast.toast(response.data.message, {
                    title: 'Product Review',
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 5000,
                    variant: 'success',
                    solid: true,
                    appendToast: true
                  });
                  self.reviewForm = {
                    subject: '',
                    description: '',
                    rating:null,
                    productid:'',
                  };
                  self.$router.push(producturl);
                  self.loadMore();    
                }else if(response.data.error == 9){
                  self.$root.forceLogout(response.data.message);
                }
              }).catch(function (error) {
                alert(error);
              });
              
            },
		
	},
	 metaInfo() {
			
			let titleMeta = 'Product Details | Alluraa';
		let descriptionMeta ='Alluraa';
		
		if (typeof(this.product.title)!= "undefined"){
			titleMeta = this.product.title+' | Alluraa';
		}
		if (typeof(this.product.short_description)!= "undefined"){
			descriptionMeta =this.product.short_description+'Alluraa';
		}
	 
		return{
			title: titleMeta,
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
				{ name: 'description', content: descriptionMeta },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>

<style scoped lang="scss">

/*.expand { width:23em;height: 25em;border:1px solid #d7d7d7;box-shadow:0px 8px 9px 0px rgb(11 0 11 / 10%)}*/


	
	 .discountoffer-txt {
        color: #ea0d14;
		/* text-transform: uppercase; 
		float: right;*/
		font-weight: 800;
		font-size: 14px
        
      } 
	  .discountoffermo-txt {
        color: #ea0d14;
		/* text-transform: uppercase; 
		*/
		font-weight: 800;
		font-size: 14px;
		float: right;
		margin-right: 10px;
        
      }
	
	#rating-inline-iRate{
		padding-left: 0px !important;
		padding-top: 0px !important;
	}

</style>